export default "__VITE_ASSET__oVOg6IR4__"